import React, { Component } from 'react';
import {v4 as uuidv4} from 'uuid';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { FILE_SIZE, FILE_TYPES, FILE_SIZE_40_MB } from 'Constants/commonConstants';
import { TOAST_ERROR } from 'Constants/actionConstants';

class Upload extends Component {
    constructor(props) {
        super(props);
        this.id = props.id ||  uuidv4();
    }

    onChange = (e)=> {
        e.preventDefault();
        const { fileSize, fileTypeNonMandatory } = this.props;
        const file = e.target.files[0];
        const fileName = file.name.toLowerCase();

        const isOutlookMessageFile = fileName.endsWith('.msg');

        if(!fileTypeNonMandatory && (FILE_TYPES.indexOf(e.target.files[0].type) === -1 && !isOutlookMessageFile)) {
            const { dispatch } = this.props;
            dispatch({
                type: TOAST_ERROR,
                message: "File Format Should Be .pdf, .jpg, .png, .jpeg, .htm, .html, .xlsx, .xls"
            })
            this.input.value="";
            return;
        } else if(e.target.files[0].size > (fileSize === 40 ? FILE_SIZE_40_MB : FILE_SIZE)) {
            const { dispatch } = this.props;
            dispatch({
                type: TOAST_ERROR,
                message: `File Size Exceeds ${fileSize || 10} MB`
            })
            this.input.value="";
            return;
        } else {
            this.props.onChange(this.input.files[0]);
            this.input.value="";
        }
        // setTimeout(()=> {
        // }, 3000)
    }

    render() {
        const { children, className, disabled, accept } = this.props;
        return (
            <label className={"pr " + className} htmlFor={this.id}>
                {
                    children   
                }
                <input
                    id={this.id}
                    ref={(ref) => { this.input = ref; }}
                    onChange={this.onChange}
                    type="file"
                    accept={ accept || ".pdf, .jpg, .png, .jpeg, .htm, .html, .xlsx, .xls"}
                    className={classNames("pa op-0 t-0 l-0 col-1 z-1 row-100 curP", {
                        inputDisabled: disabled,
                    })}
                    disabled={disabled}
                />
                
            </label>
        )
    }
}

export default connect()(Upload);